import BasePhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const PhoneInput = ({ ...attrs }) => {
  return <div
    className="w-full pl-4 pr-4 border border-gray-500 bg-white"
    style={{
      borderRadius: '1.5rem'
    }}>
    <BasePhoneInput
      {...attrs}
      numberInputProps={
        {
          style: {
            border: '0',
            outline: 'none!important'
          }
        }
      } />
  </div>
}

export default PhoneInput
